export default __webpack_public_path__ + "static/tr-6c626f7920453a728d36e9270079a6ab.svg";